import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw24px = 'M20.71,7.639v10.73a3.764,3.764,0,0,1-3.75,3.75H13.95v-1.5h3.01a2.253,2.253,0,0,0,2.25-2.25V8.639H13.95V3.389H7.06a2.247,2.247,0,0,0-2.25,2.25l-.06,3.37-1.5-.02.06-3.37a3.747,3.747,0,0,1,3.75-3.73h7.89ZM14,16.749h-.31a5.72,5.72,0,0,1-4.94,4.94V22a.75.75,0,0,1-1.5,0v-.31a5.72,5.72,0,0,1-4.94-4.94H2a.75.75,0,1,1,0-1.5h.31a5.72,5.72,0,0,1,4.94-4.94V10a.75.75,0,0,1,1.5,0v.31a5.72,5.72,0,0,1,4.94,4.94H14a.75.75,0,0,1,0,1.5ZM11.25,16a.755.755,0,0,1,.75-.75h.18a4.258,4.258,0,0,0-3.43-3.43V12a.75.75,0,1,1-1.5,0v-.18a4.258,4.258,0,0,0-3.43,3.43H4a.75.75,0,1,1,0,1.5H3.82a4.245,4.245,0,0,0,3.43,3.43V20a.75.75,0,0,1,1.5,0v.18a4.245,4.245,0,0,0,3.43-3.43H12A.749.749,0,0,1,11.25,16Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const DocumentCrosshairIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'documentCrosshair'));
DocumentCrosshairIcon.displayName = 'DocumentCrosshairIcon';
DocumentCrosshairIcon.propTypes = Icon.propTypes;
DocumentCrosshairIcon.renderIcon = props => /*#__PURE__*/React.createElement(DocumentCrosshairIcon, props);
export default DocumentCrosshairIcon;
//# sourceMappingURL=DocumentCrosshairIcon.js.map